import { Modal, Button } from "antd";
import { updateSosStatusApi } from "api/sos";
import WarningIcon from "components/Icons/WarningIcon";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ISos } from "models/sos";
import { useState } from "react";

interface IProp {
  open: boolean;
  sos: ISos;
  handleClose: () => void;
}

export default function DeactivateModal({ open, sos, handleClose }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadSos } = useDataLoadingContext();
  const handleApprove = async () => {
    setLoading(true);
    const { data, error } = await updateSosStatusApi(sos.id);
    if (data) {
      showSuccess("Sos Deactivated successfully");
      loadSos();
    } else showError(error!.message);
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
          <WarningIcon />
        </div>
        <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
        <p
          className="font-normal text-base"
          style={{ color: "rgba(0,0,0,.64)" }}
        >
          You're about to Deactivate sos
        </p>
        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleApprove} loading={loading} type="primary">
            Deactivate
          </Button>
        </div>
      </div>
    </Modal>
  );
}
